import React from "react";

import { VendorSplitModal } from "components/TransactionSplits/NewVendorSplitModal/index";

import { ModalTypes } from "constants/navigation";

import { getLivestockSaleId } from "lib/navigation";

import { useModalAdapter } from "hooks";

function VendorSplitModalAdapter(props) {
  const [hashParams, returnTo, onClose] = useModalAdapter(
    ModalTypes.VendorSplit,
    props,
  );
  const {
    deploymentId,
    primaryBusinessId,
    saleLotId = null,
    consignmentId = null,
    isDefault = false,
    livestockSaleId = getLivestockSaleId(),
  } = hashParams;

  return (
    <VendorSplitModal
      key={JSON.stringify(hashParams)}
      deploymentId={deploymentId}
      consignmentId={consignmentId}
      saleLotId={saleLotId}
      primaryBusinessId={primaryBusinessId}
      livestockSaleId={livestockSaleId}
      isDefault={isDefault}
      onClose={onClose}
      returnTo={returnTo}
    />
  );
}

export default VendorSplitModalAdapter;
